import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Quiz } from '../models/quiz';

@Injectable({
  providedIn: 'root'
})
export class QuizService {

  constructor(
    private _http: HttpClient
  ) { }

  public deleteAnswer(
    answerId:number
  ) {
    return this._http.delete(environment.apiEndpoint+'/api/admin/quiz/answer/'+answerId).pipe(
      map(res => {
        return res;
      })
    );
  }

  public addAnswer(
    quizId:number,
    questionId:number
  ) {
    return this._http.post(environment.apiEndpoint+'/api/admin/quiz/answer', {quizId:quizId, questionId:questionId}).pipe(
      map(res => {
          return res;
      })
    );  
  }

  public addQuestion(quizId:number){
    return this._http.post(environment.apiEndpoint + '/api/admin/quiz/question', {quizId:quizId}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public deleteQuestion(questionId:number){
    return this._http.delete(environment.apiEndpoint + '/api/admin/quiz/question/' + questionId).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public saveQuiz(
    quiz: Quiz
  ) {
    return this._http.put(environment.apiEndpoint+'/api/admin/quiz/'+quiz.id, {quiz:quiz}).pipe(
      map(res => {
        return res;
      })
    );
  }
}
